import React, { useEffect, useState } from "react";
import ScreenshotsFilter from "../modals/ScreenshotsFilter";
import ScreenshotDetectedText from "../modals/ScreenshotDetectedText";
import DeleteSelectedScreenshot from "../modals/DeleteSelectedScreenshot";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import {
  deleteScreenshot,
  getActivityScreenshotList,
  getManualScreenshotList,
} from "../../AxiosRtk/Screenshot";
import moment from "moment";
import Download from "../modals/Download";
import {
  formattedDateTime,
  handleStartDateCommon,
} from "../../../../utils/helper";
import { isEmpty } from "lodash";
import ViewPicture from "../modals/ViewPicture";
import useDeviceStatus from "../../../customHooks/deviceStatusProvider";
import { setShowMessage } from "../../AxiosRtk/successMessage";
import useLangTranslation from "../../../customHooks/languageProvider";
import useDurationOption from "../../../customHooks/durationOption";
import KidImage from "../../../shared/KidImage/KidImage";
import DateFilter from "../../../shared/DateFilter/DateFilter";
import { useDashboardDataProvider } from "../../../customHooks/dashboardDataProvider";
import useKidListFunctionality from "../../../customHooks/kidListHook";
import useFirebase from "../../../../useFirebase";

const Screenshots = (props) => {
  const { getLangTranslation } = useLangTranslation();
  const { durationOptionsFunction } = useDurationOption();
  const { handleDeviceSelection } = useDashboardDataProvider();
  const [selectedDuration, setSelectedDuration] = useState(1);
  const durationOptions = durationOptionsFunction();
  const dispatch = useDispatch();
  const history = useHistory();
  const initialEndDate = moment().locale("en").format("YYYY-MM-DD HH:mm:ss");
  const [endDate, setEndDate] = useState(initialEndDate);
  const [kidData, setKidData] = useState(false);
  const { getImage } = useKidListFunctionality();

  const [startDate, setStartDate] = useState(
    moment().startOf("day").format("YYYY-MM-DD HH:mm:ss")
  );
  const { ID: parentID } = useSelector(({ auth }) => auth.user);
  const [filterData, setFilterData] = useState({
    selectedPackages: [],
    selectedCategoryIds: [],
    selectedKeyWords: [],
  });
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [detectedTextModal, setDetectedTextModal] = useState(false);
  const [screenshotListData, setScreenshotListData] = useState([]);
  const [deletedSelectedModal, setDeletedSelectedModal] = useState(false);
  const [selectedScreenshots, setSelectedScreenshots] = useState([]);
  const [downloadModal, setDownloadModal] = useState(false);
  const [viewPictureModal, setViewPictureModal] = useState(false);
  const [deviceStatus, setDeviceStatus] = useState(-1);
  const [detectedTextData, setDetectedTextData] = useState("");
  

  const [selectToBeDeleted, setSelectToBeDeleted] = useState(0);
  const { kidList, selectedKidId, kidDevicesList, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );

  const { setRulesData } = useSelector(({ setRules }) => setRules);

  const detectTextenable = setRulesData?.screenshotsSettings?.screenshotSmartTextDetection;
  
  const handleGoBack = () => {
    history.goBack();
  };
  const selectedKidData = kidList?.find((item) => item?.ID === selectedKidId);

  useEffect(() => {
    setKidData(kidList?.find((item, index) => item.ID === selectedKidId));
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (selectedDeviceData) {
      if (props?.location?.pathname === "/manual-screenshots") {
        getManualScreenshotHistory(selectedDeviceData?.ID);
      }
    }
  }, [selectedDeviceData]);

  useEffect(() => {
    if (selectedDeviceData) {
      getDeviceStatusData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData]);

  const openViewPicture = (item) => {
    if (props?.location?.pathname === "/manual-screenshots") {
      const manualScreenshotUrl = `${process.env.REACT_APP_AMAZON_S3_IMAGE_URL_PREFIX_NEW
        }/${btoa(parentID)}/ManualScreenshots/${item}`;
      setSelectedItem(manualScreenshotUrl);
    } else {
      setSelectedItem(item);
    }
    setViewPictureModal(true);
  };

  const closeViewPicture = () => {
    setViewPictureModal(false);
  };

  function getActivityScreenshotHistory() {
    if (selectedDeviceData && startDate) {
      const filterDate = moment(startDate)
        .locale("en")
        .format("YYYY-MM-DD HH:mm:ss");
      const obj = {
        kidId: selectedKidId,
        deviceId: selectedDeviceData?.ID,
        deletedImages: selectToBeDeleted,
        changeOneDate: startDate,
        nowTime: endDate,
        appPackageNames: filterData ? filterData?.selectedPackages : "",
      };
      getActivityScreenshotList(obj)
        .then((res) => {
          setScreenshotListData(res?.data?.result);
        })
        .catch((err) => {
          console.log("rating catch error ==>>", err?.response?.data?.message);
        });
    }
  }

  function getManualScreenshotHistory(deviceId) {
    const data = {
      kidId: selectedKidId,
      deviceId: deviceId,
    };
    getManualScreenshotList(data)
      .then((res) => {
        setScreenshotListData(res?.data?.result);
      })
      .catch((err) => {
        console.log(
          "getting manual screenshots catch error ==>>",
          err?.response?.data?.message
        );
      });
  }

  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };
  const openDetectedTextModal = (item) => {
    setDetectedTextData(item);
    setDetectedTextModal(true);
  };
  const closeDetectedTextModal = () => {
    setDetectedTextModal(false);
  };
  const openDeletedSelected = () => {
    setDeletedSelectedModal(true);
  };
  const closeDeletedSelected = () => {
    setDeletedSelectedModal(false);
  };
  const closeDownloadPicture = () => {
    setDownloadModal(false);
  };
  const handleCheckboxChange = (screenshotId) => {
    if (selectedScreenshots.includes(screenshotId)) {
      setSelectedScreenshots(
        selectedScreenshots.filter((id) => id !== screenshotId)
      );
    } else {
      setSelectedScreenshots([...selectedScreenshots, screenshotId]);
    }
  };

  const handleSelectAllChange = () => {
    if (selectedScreenshots.length === screenshotListData.length) {
      setSelectedScreenshots([]);
    } else {
      setSelectedScreenshots(
        screenshotListData.map((item) => item.screenshotId)
      );
    }
  };
  useEffect(() => {
    if (props?.location?.pathname === "/screenshots") {
      getActivityScreenshotHistory();
    }
  }, [
    startDate,
    endDate,
    selectedDeviceData?.ID,
    selectToBeDeleted,
    filterData.selectedKeyWords,
    filterData.selectedPackages,
  ]);

  const handleSelectToBeDeletedCheckbox = () => {
    setSelectToBeDeleted((prevValue) => (prevValue === 0 ? 1 : 0));
  };

  const handleDelete = async (type) => {
    if (!isEmpty(selectedScreenshots)) {
      const payload = {
        screenshotActivityId: selectedScreenshots.join(","),
        activityType: "SCREENSHOTS",
        deviceId: selectedDeviceData?.ID,
        isDeleteAll: 0,
        isAlertDelete: 0,
      };
      try {
        const { data } = await deleteScreenshot(payload);
        if (data) {
          closeDeletedSelected();
          setSelectedScreenshots([]);
          getActivityScreenshotHistory();

          setTimeout(() => {
            dispatch(
              setShowMessage({
                showMessage: true,
                defaultMessage: data?.message,
                message: data?.message,
              })
            );
          }, 800);
        }
      } catch (error) {
        closeDeletedSelected();
        console.log(error);
      }
    }
  };

  function getScreenshot(imgUrl) {
    if (imgUrl?.includes("https:")) {
      return imgUrl;
    }

    if (props?.location?.pathname === "/manual-screenshots") {
      return `${process.env.REACT_APP_AMAZON_S3_IMAGE_URL_PREFIX_NEW}/${btoa(
        parentID
      )}/ManualScreenshots/${imgUrl}`;
    } else {
      return `${process.env.REACT_APP_AMAZON_S3_IMAGE_URL_PREFIX_NEW}/${btoa(
        parentID
      )}/Screenshots/${imgUrl}`;
    }
  }

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <div
                    className="text-blue-900 fs-5 cursor-pointer"
                    onClick={handleGoBack}
                  >
                    <i
                      className={`${lang?.isRTL === 1
                          ? "icon-arrow-right"
                          : "icon-arrow-left"
                        }`}
                    />
                  </div>
                  <h3 className="text-blue-900 mb-0">
                    {" "}
                    {getLangTranslation(
                      "CHILD_DETAIL_APP_SCREENSHOT",
                      "Screenshots"
                    )}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              <span className="icon-wrap icon-rounded me-2 p-0 overflow-hidden ratio ratio-1x1 border-0">
                <img
                  src={getImage(kidData?.image, kidData?.gender)}
                  alt=""
                  className="img-fluid"
                  onError={(event) => {
                    event.target.onerror = null;
                    event.target.src = getImage("", kidData?.gender);
                  }}
                />
              </span>
              <div className="list-content">
                <h5 className="text-blue-900 mb-0">
                  {selectedKidData?.childName}
                </h5>
                {deviceStatus === 1 && (
                  <p className="mb-0 text-small text-success">
                    <span
                      className={`badge rounded-pill d-inline-block badge-sm bg-success ${lang?.isRTL === 1 ? "ms-1" : " me-1"
                        }`}
                    ></span>
                    {getLangTranslation(
                      "CHILD_DASHBOARD_ACTIVE_NOW",
                      "Active Now"
                    )}
                  </p>
                )}

                {deviceStatus === 0 && (
                  <p className="mb-0 text-small text-danger">
                    <span
                      className={`badge rounded-pill d-inline-block badge-sm bg-danger ${lang?.isRTL === 1 ? "ms-1" : " me-1"
                        }`}
                    ></span>
                    {getLangTranslation(
                      "CHILD_DEVICE_INACTIVE_NOW",
                      "Inactive Now"
                    )}
                  </p>
                )}
              </div>
            </div>
            <div className="list-item col-12 col-md-3">
              <div className="select-with-icon">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                <Select
                  className="custom-select"
                  classNamePrefix="custom-select"
                  placeholder={getLangTranslation(
                    "SCREENSHOT_HISTORY_SELECT_DEVICE_TITLE",
                    "Select Device"
                  )}
                  options={deviceOptions.length > 0 ? deviceOptions : []}
                  value={
                    deviceOptions?.find(
                      (item) => item?.value == selectedDeviceData?.ID
                    ) || ""
                  }
                  onChange={handleDeviceSelection}
                  isSearchable={false}
                  styles={{
                    placeholder: (base) => ({
                      ...base,
                      marginBottom: selectedDeviceData ? "12px" : "0px", // Adjust this value as needed
                    }),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-6 mb-6">
            <div className="d-flex align-items-center flex-wrap gap-6">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  name="allSelect"
                  id="selectAll"
                  checked={
                    selectedScreenshots.length > 0 &&
                    selectedScreenshots.length === screenshotListData.length
                  }
                  onChange={handleSelectAllChange}
                />
                <label
                  className="form-check-label text-dark"
                  htmlFor="selectAll"
                >
                  {getLangTranslation(
                    "SCREENSHOT_HISTORY_SELECT_ALL",
                    "Select All"
                  )}
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  name="allSelect"
                  id="deletedSoon"
                  checked={selectToBeDeleted === 1}
                  onChange={handleSelectToBeDeletedCheckbox}
                />
                <label
                  className="form-check-label text-dark"
                  htmlFor="deletedSoon"
                >
                  {getLangTranslation(
                    "SCREENSHOT_HISTORY_SELECT_TO_BE_DELETED_SOON",
                    "Select to be deleted soon"
                  )}
                </label>
              </div>
              <button
                className="btn btn-outline-primary"
                type="button"
                onClick={openDeletedSelected}
              >
                {getLangTranslation(
                  "SCREENSHOT_HISTORY_BUTTON_DELETE_SELECTED",
                  "Delete selected"
                )}
              </button>
            </div>
            <div className="d-flex align-items-center gap-3 justify-content-end flex-fill">
              <DateFilter
                startDate={startDate}
                endDate={endDate}
                setEndDate={setEndDate}
                setStartDate={setStartDate}
                selectedDuration={selectedDuration}
              />
              <Select
                className="custom-select col-lg-3"
                classNamePrefix="custom-select"
                placeholder="Select"
                onChange={(val) => {
                  handleStartDateCommon(
                    val,
                    setStartDate,
                    setSelectedDuration,
                    setEndDate
                  );
                }}
                options={durationOptions}
                value={
                  durationOptions?.find(
                    (item) => item?.value == selectedDuration
                  ) || ""
                }
              />
              <span className="icon-wrap pt-cursor" onClick={openModal}>
                <i className="icon-filter" />
              </span>
            </div>
          </div>
          {screenshotListData?.length > 0 ? (
            <div className="grid gap-6">
              {screenshotListData?.map((item, index) => {

                return (
                  <div className="g-col-12 g-col-md-6 g-col-lg-4" key={index}>
                    <div className=" ratio ratio-5x3 mb-3">
                      <img
                        className="rounded-3 cursor-pointer"
                        src={getScreenshot(item?.screenShotUrl)}
                        alt=""
                        onClick={() => {
                          openViewPicture(item?.screenShotUrl);
                        }}
                      />
                      <input
                        className="form-check-input top-0 start-100 mt-3"
                        style={{ marginLeft: "-2rem" }}
                        type="checkbox"
                        value=""
                        checked={selectedScreenshots.includes(
                          item.screenshotId
                        )}
                        onChange={() => handleCheckboxChange(item.screenshotId)}
                      />{" "}
                    </div>
                    <div className="d-flex align-items-center gap-3 mb-3">
                      <div className="icon-wrap m-social">
                        <img src={item?.image} alt="" width="30" />
                      </div>
                      <div className="d-flex flex-column">
                        <h5 className="text-small text-blue-900 mb-1">
                          {item?.app_name && item?.app_name != "null"
                            ? item?.app_name
                            : "--"}
                        </h5>
                        <span className="text-gray text-small">
                          {formattedDateTime(item?.screenShotDateTime)}
                        </span>
                      </div>
                      <a
                        href={getScreenshot(item?.screenShotUrl)}
                        className="icon-wrap icon-blue ms-auto pt-cursor"
                      >
                        {" "}
                        <i className="icon-download fs-5" />
                      </a>
                    </div>
                    {detectTextenable === 1 && (
                      <div className="d-flex align-items-center justify-content-between gap-3">
                        {item?.screenshotPredictCategory ? (
                          <div className="badge-pill danger">
                            {item?.screenshotPredictCategory}
                          </div>
                        ) : (
                          <div></div>
                        )}

                        <span
                          className="text-blue-400 pt-cursor text-decoration-underline text-break"
                          onClick={() => openDetectedTextModal(item)}
                        >
                          {getLangTranslation(
                            "SCREENSHOT_DETECTED_TEXT",
                            "Detected text"
                          )}
                        </span>
                      </div>
                    )}

                  </div>
                );
              })}
            </div>
          ) : (
            <div className="text-center my-2">
              {getLangTranslation("NO_DATA_LOG", "No data found")}
            </div>
          )}
        </div>
      </div>
      <ScreenshotsFilter
        showModal={showModal}
        closeModal={closeModal}
        filterData={filterData}
        setFilterData={setFilterData}
        getLangTranslation={getLangTranslation}
      />
      <ScreenshotDetectedText
        showModal={detectedTextModal}
        closeModal={closeDetectedTextModal}
        getLangTranslation={getLangTranslation}
        detectedTextData={detectedTextData}
        getScreenshot={getScreenshot}
      />
      <DeleteSelectedScreenshot
        selectedDeviceId={selectedDeviceData?.ID}
        selectedScreenshots={selectedScreenshots}
        showModal={deletedSelectedModal}
        closeModal={closeDeletedSelected}
        handleDelete={handleDelete}
        onlyFirstOption={true}
        getLangTranslation={getLangTranslation}
      />
      <Download
        showModal={downloadModal}
        closeModal={closeDownloadPicture}
        getLangTranslation={getLangTranslation}
      />
      <ViewPicture
        showModal={viewPictureModal}
        closeModal={closeViewPicture}
        selectedItem={selectedItem}
        getLangTranslation={getLangTranslation}
      />
    </>
  );
};

export default Screenshots;
